/**
 
 */

window._ = require('lodash');

window.axios = require('axios');
window.axios.defaults.baseURL =
    process.env.NODE_ENV == "production"
        ? 'https://eys.hacibayram.edu.tr:8081/api'
        : 'https://eys.hacibayram.edu.tr:8081/api';

